import { Anchor, Button, H2 } from "@sellar-io/components";
import { formatCurrency } from "@sellar-io/common";
import {
  SignupFlowStep,
  useSignupContext,
} from "../../../../../hooks/useSignupContext.shared";
import { useSellarUser } from "../../../../../hooks";
import { useLocalStorage } from "usehooks-ts";
import { useNavigate } from "react-router";
import { DISCOVER } from "../../../../../constants/routes";

export const CreditEligibleStepContent = () => {
  const { changeBusiness } = useSellarUser();
  const {
    setStep,
    signupDialogActive,
    endOnboarding,
    setRedirectToSellarCreditOnboarding,
    setRedirectToMarket,
    creditLimitQuoteValue,
    buyerSignUpBusinessId,
  } = useSignupContext();
  const [_, setOnboardingContinueUrl] = useLocalStorage<string | null>(
    "onboardingContinueUrl",
    null,
  );

  const navigate = useNavigate();

  const onClaimCredit = () => {
    setOnboardingContinueUrl(null);

    // change business if value set

    if (buyerSignUpBusinessId) {
      changeBusiness(buyerSignUpBusinessId);
    }

    if (signupDialogActive) {
      navigate(`${DISCOVER}?showSellarCreditOnboarding=true`);
      return endOnboarding();
    }

    setRedirectToSellarCreditOnboarding(true);
    endOnboarding();
  };

  const onSkipForNow = () => {
    // change business

    if (buyerSignUpBusinessId) {
      changeBusiness(buyerSignUpBusinessId);
    }

    // if sign up dialog active, show complete onboarding step (handles draft basket)

    if (signupDialogActive) {
      return setStep(SignupFlowStep.ConfirmationStep);
    }

    // otherwise, complete sign up flow and navigate to market

    setRedirectToMarket(true);
    endOnboarding();
  };

  return (
    <div className="flex flex-col gap-4 text-center text-zinc-800">
      <div className="flex flex-col items-center gap-6">
        <img
          src="https://sellar.imgix.net/sellar-image-assets/sellar-credit/sc-invoice.svg"
          className="w-[190px]"
        />
      </div>
      <H2>
        Sign up to Sellar Credit to claim your{" "}
        {formatCurrency(creditLimitQuoteValue)} credit limit
      </H2>

      <p>
        Boost cash flow, save on admin time and support the industry as your
        suppliers get paid upfront whilst you pay no fees or interest
      </p>

      <p>
        You can claim your Sellar Credit account today by completing sign up, or{" "}
        <Anchor
          className="font-semibold text-blue-700 underline"
          href="https://sellar.io/sellar-credit-for-buyers"
          target="_blank"
        >
          find out more
        </Anchor>{" "}
        on our website
      </p>

      <div className="mt-4 flex w-full flex-col gap-2">
        <Button className="w-full" onClick={() => onClaimCredit()}>
          SIGN UP FOR SELLAR CREDIT
        </Button>
        <Button
          color="secondary"
          className="w-full"
          onClick={() => onSkipForNow()}
        >
          SKIP FOR NOW
        </Button>
      </div>
    </div>
  );
};
